import script from "./TermsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsModal.vue?vue&type=script&setup=true&lang=js"

import "./TermsModal.vue?vue&type=style&index=0&id=0d1ca814&lang=css"

const __exports__ = script;

export default __exports__